// Pure format/time helpers shared by the results template, the other fcb
// templates and the image-editor previews. They live here rather than in
// Index.jsx so ResultOverlay can use them without importing its own parent.

// Bottom scrim painted over each background layer so the score block stays
// readable. Shared with the image editor's canvas, which draws its own
// (draggable) copies of these layers and has to darken them the same way —
// the fcb templates do not all use the same stops, so this one is ours.
export const LAYER_BOTTOM_GRADIENT =
  "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(20, 20, 20, 0.7) 40%, rgba(30,30,30,1) 100%)";

export const sortByTimeFirst = (arr) => {
  const getMinute = (timeStr) => {
    if (!timeStr) return 0;
    const base = timeStr.split('+')[0];
    return parseInt(base, 10);
  };

  return arr.sort((a, b) => {
    return getMinute(a.times[0]) - getMinute(b.times[0]);
  });
};

export const ratioFromFormat = (format) => {
  // return 0;
  if (format === '1920x1080') return 1.78;
  if (format === '1200x1500') return 0.8;
  return 0.56;
}

export const formatFromRatio = (ratio) => {
  if (ratio === 1.78) return '1920x1080';
  if (ratio === 0.8) return '1200x1500';
  return '1080x1920';
}

export const ratioStringFromFormat = (format) => {
  if (format === '1920x1080') return '16/9';
  if (format === '1200x1500') return '4/5';
  return '9/16';
}

export const parseMinute = (min) => {
  const s = String(min);
  if (s.includes('+')) {
    const [main, extra] = s.split('+').map(Number);
    return (Number.isNaN(main) ? 0 : main) * 100 + (Number.isNaN(extra) ? 0 : extra);
  }
  const n = Number(s);
  return (Number.isNaN(n) ? 0 : n) * 100;
};

export const formatMinute = (min) => {
  const s = String(min);
  if (s.includes('+')) {
    const [main, extra] = s.split('+');
    return `${main}'+${extra}`;
  }
  if (s.includes(' (P)')) {
    const [main, extra] = s.split(' (P)');
    return `${main}' (P)`;
  }
  if (s.includes(' (OG)')) {
    const [main, extra] = s.split(' (OG)');
    return `${main}' (OG)`;
  }
  if (parseInt(min) > 90) {
    const extra = parseInt(min) - 90;
    return `90'+${extra}`;
  }
  return `${s}'`;
};
